import { render, staticRenderFns } from "./UserOnlineBody.vue?vue&type=template&id=7f64aa78&"
import script from "./UserOnlineBody.vue?vue&type=script&lang=ts&"
export * from "./UserOnlineBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports